import { Organization } from '../../domain/organization/dto/Organization';

export class RegExpService {

  /** ============== IMPORTANT NOTE =============================
   *  If you want use regex from ChatGPT or other sources like '^(?!$)\d+(\.\d+)?$' add additionally `\` to each slash
   *  and use ^(?!$)\\d+(\\.\\d+)?$ instead
   *  ===========================================================
   */

  static email = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

  /**
   * Only symbols which can be used in phone number: +, -, (, ), space, 0-9
   */
  static phoneOrEmpty = '^[- +()0-9]*$';

  /**
   * not negative number _OR_ empty string.
   * valid:
   * '', '34', '435345' ;
   * invalid:
   * '-4343', '343x', 'name'.
   */
  static notNegativeNumbersOrEmpty = '^(\\d*)$';

  /**
   * positive number only.
   * valid:
   * '34', '435345';
   * invalid:
   * '-4343', '343x', 'name', ''.
   */
  static positiveNumbersOnly = '^(\\d*[1-9]+\\d*)$';

  /*
  * same as positiveNumbersOnly previous just including zero
  */
  static positiveNumbersOnlyIncludeZero = '^(\\d*[0-9]+\\d*)$';

  static positiveNumbersOnlyOrEmpty = '^(\\d*[0-9]+\\d*)?$';

  /**
   * any integer number _OR_ empty digit
   * valid:
   * '', '-3000', '3000';
   * invalid:
   * '1.1', '111x', '-'.
   */
  static integerOrNull = '^(-?(\\d*)|(\\d*))$';

  static dateAsString$ = /^\d{4}-\d{2}-\d{2}$/;

  /**
   * any decimal number _OR_ empty digit
   * valid:
   * '', '3.44', '5', '1.';
   * invalid:
   * '111x', '-', '-17', '-1.2', '.7', '1.22.'
   */
  static partialNotNegativeDecimalNumbersOrEmpty = '^(?!$)\\d+(\\.\\d*)?$';
  /**
   * Same as {@link partialNotNegativeDecimalNumbersOrEmpty}, but this one does NOT allow
   * unfinished values like '1.'
   */
  static notNegativeDecimalNumbersOrEmpty = '^(?!$)\\d+(\\.\\d+)?$';

  /**
   * Date separated by slashes:
   * valid:
   * '1/1/2024', '01/1/2024', '1/01/2024', '01/01/2024';
   * invalid:
   * '1.1.2024', '1/1/24'
   */
  static dateSeparatedBySlashes = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

  static hasLetters = /[a-zA-Z]+/;

  uuidV4 = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

  /**
   * <pre>
   * Checks the Investor code on first 2 values: OOOO-FFF-IIII
   * Where OOOO is an Organization ID (id connected with portal, not entity ID).
   * Where FFF is an Fund ID (id connected with portal, not entity ID).
   * Where IIII is an Investor ID (can be extended).
   *
   * Fund can start with up to 2 empty zeroes.
   *
   * E.x.
   * Fund ID = 1; Org ID = 7700;
   * Legit | 7700-1-1 | 7700-01-1 | 7700-001-1 | 7700-01-1-1
   * Not legit | 4000-1-1 | 7700-0001-1 | 7700-1-
   * </pre>
   *
   * @param org with selected fund.
   */
  static investorCode(org: Organization): string {
    return `^${org.organizationId}-(0){0,2}${org.selectedFund.fundId}-\\d{1,}$`;
  }
}
